import React from "react";
import IncrementCounter from "../../common/IncrementCounter";

function Summary() {
  return (
    <section className="ttm-row zero_padding-section ttm-bgcolor-grey clearfix">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-white spacing-7 z-index-1">
              <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
              <div className="layer-content">
                <div className="row row-equal-height no-gutters">
                  <div className="col-lg-4 col-md-12">
                    <div className="featured-icon-box icon-align-before-content style5 icon-ver_align-top ttm-bgcolor-skincolor">
                      <div className="featured-icon">
                        <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-white ttm-icon_element-size-lg">
                          <i className="flaticon flaticon-optical-2"></i>
                        </div>
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h3>Affordable Eye Care</h3>
                        </div>
                        <div className="featured-desc">
                          <p>
                            Vitreous and Retinal diseases: Lasers for Diabetic
                            Retinopathy, ROP, Retinal Holes; Injections for
                            ARMD, CNVM, PDR; Retinal Detachment, Vitreous
                            Hemorrhage, Macular Hole, Endophthalmitis.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div className="featured-icon-box icon-align-before-content style5 icon-ver_align-top ttm-bgcolor-darkgrey">
                      <div className="featured-icon">
                        <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-white ttm-icon_element-size-lg">
                          <i className="flaticon flaticon-eye-exam-2"></i>
                        </div>
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h3>Why Prasad Eye Hospital</h3>
                        </div>
                        <div className="featured-desc">
                          <p>
                            Phaco-emulsification for Cataract with premium IOLs,
                            SFIOL implantation, and combined Cataract-Glaucoma
                            and Cataract-vitreo-retinal surgeries.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div className="featured-icon-box icon-align-before-content style5 icon-ver_align-top ttm-bgcolor-skincolor">
                      <div className="featured-icon">
                        <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-white ttm-icon_element-size-lg">
                          <i className="flaticon flaticon-computer"></i>
                        </div>
                      </div>
                      <div className="featured-content">
                        <div className="featured-title">
                          <h3>Eye Experts</h3>
                        </div>
                        <div className="featured-desc">
                          <p>
                            Full spectrum of Anterior and Posterior Segment
                            Trauma management with advanced investigative
                            facilities: Indirect Ophthalmoscopy, Corneal
                            Topography, Biometry, Ultrasonography, Gonioscopy,
                            CCT, VEP.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row padding_top90 res-991-padding_top50">
                  <div className="col-lg-6 col-md-12">
                    <div className="d-inline-block position-relative">
                      <div className="ttm_single_image-wrapper text-left">
                        <img
                          className="img-fluid"
                          src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/bg-image/single-img-06.png"
                          alt="single_06"
                        />
                      </div>
                      <div className="d-table align-items-center mt_200 margin_bottom120 box-shadow">
                        <div className="d-table-cell align-middle position-relative ttm-bgcolor-white p-50 padding_top25 padding_bottom25 res-991-p-10 res-991-padding_left20 res-991-padding_right20">
                          <h2 className="fs-18 mb-0">
                            We are insured, and reliable
                          </h2>
                        </div>
                        <span className="d-table-cell align-middle">
                          <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-square mb-0 border-0">
                            <i className="fa fa-angle-right"></i>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-xs-12">
                    <div className="padding_left15 res-991-padding_left0 padding_top30 res-991-padding_top50">
                      <div className="section-title">
                        <div className="title-header">
                          <h3>EyeCare</h3>
                          <h2 className="title">
                            Meet Prasad Eye Hospital Online To Get Personalized
                            Treatment
                          </h2>
                        </div>
                        <div className="heading-seperator">
                          <span></span>
                        </div>
                        <div className="title-desc">
                          <p>
                            Connecting us with evry easy by creating an account.
                            By signing up, your one step closer to connecting
                            with a doctor in your area.Eye care isn’t one size
                            fits all.
                          </p>
                          <p>
                            Waiting is the worst. Our goal is to connect you
                            with a provider within an hour. If you need a
                            prescription, it can be sent directly.
                          </p>
                        </div>
                      </div>
                      <div className="row padding_top15">
                        <div className="col-lg-6 col-md-5 col-sm-6 padding_right20">
                          <div className="featured-icon-box icon-align-before-title icon-ver_align-top style6">
                            <div className="featured-icon">
                              <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                <i className="fa fa-play"></i>
                              </div>
                            </div>
                            <div className="featured-title">
                              <h3>Professional Technicians</h3>
                            </div>
                            <div className="featured-content">
                              <div className="featured-desc">
                                <p>
                                  Enhancing Your Vision to dolor situation
                                  adipisicing.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="featured-icon-box icon-align-before-title icon-ver_align-top style6">
                            <div className="featured-icon">
                              <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                <i className="fa fa-play"></i>
                              </div>
                            </div>
                            <div className="featured-title">
                              <h3>Passion For Healing</h3>
                            </div>
                            <div className="featured-content">
                              <div className="featured-desc">
                                <p>
                                  We are aim to enhance overall body health for
                                  each.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-5 col-sm-6">
                          <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-topicon style2 ttm-bgcolor-grey p-30 res-991-p-30">
                            <div className="ttm-fid-icon-wrapper ttm-textcolor-skincolor">
                              <i className="flaticon flaticon-eye-3"></i>
                            </div>
                            <div className="ttm-fid-contents">
                              <h4 className="ttm-fid-inner">
                                {
                                  <IncrementCounter
                                    intialCount={10000}
                                    startYear={2025}
                                    incrementPerYear={2000}
                                    classes="numinate"
                                  />
                                }
                                +
                              </h4>
                              <h3 className="ttm-fid-title">
                                Successfully <br />
                                Eye Surgery
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Summary;
